// Product Status Translation Utility
// Database uses English, UI displays Arabic

export const PRODUCT_STATUS = {
  'original_new': 'اصلي جديد',
  'original_used': 'اصلي مستعمل',
  'commercial_new': 'جديد تجاري'
};

export const PRODUCT_STATUS_REVERSE = {
  'اصلي جديد': 'original_new',
  'اصلي مستعمل': 'original_used',
  'جديد تجاري': 'commercial_new',
  // Variations
  'اصلى جديد': 'original_new',
  'اصلى مستعمل': 'original_used',
  'جديدتجاري': 'commercial_new'
};

// Get Arabic translation for English status
export const getStatusLabel = (status) => {
  if (!status) return '';
  return PRODUCT_STATUS[status] || status;
};

// Get English value for Arabic label
export const getStatusValue = (label) => {
  if (!label) return '';
  return PRODUCT_STATUS_REVERSE[label] || label;
};
